var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series.length)?_c('GlobalGraph',{staticClass:"graph",attrs:{"graphID":_vm.title,"series":_vm.series,"xAxisData":_vm.xAxis,"yAxis":_vm.yAxis,"title":_vm.graphTitle,"theme":_vm.theme,"loading":_vm.loading}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }